import { CASH_PAYMENT_REQUEST, GET_CASH_PAYMENTS, CREATE_CASH_PAYMENT, UPDATE_CASH_PAYMENT, DELETE_CASH_PAYMENT, CASH_PAYMENT_REQUEST_FAILURE,
  CASH_PAYMENT_REQUEST_SUCCESS, GET_CASH_PAYMENTS_PAGE } from '../types';

const initialState = {
  cashPayments: [],
  cashPaymentsPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const cashPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case CASH_PAYMENT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_CASH_PAYMENTS: {
      return {
        ...state,
        cashPayments: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_CASH_PAYMENTS_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        cashPaymentsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_CASH_PAYMENT: {
      return {
        ...state,
        cashPayments: [action.payload, ...state.cashPayments],
        loading: false,
        error: null
      };
    }
    case UPDATE_CASH_PAYMENT: {
      const cashPaymentsData = state.cashPayments.slice(0);
      const uIndex = cashPaymentsData.findIndex((data) => data.id === action.payload.id);
      cashPaymentsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        cashPayments: [ ...cashPaymentsData ],
        loading: false,
        error: null
      };
    }
    case DELETE_CASH_PAYMENT: {
      const cashPayments = state.cashPayments?.slice(0);
      const index = cashPayments.findIndex((data) => data.id === action.id);
      if (index > -1) {
        cashPayments.splice(index, 1);
      }
      return {
        ...state,
        cashPayments: [...cashPayments],
        loading: false,
        error: null
      }
    }
    case CASH_PAYMENT_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case CASH_PAYMENT_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default cashPaymentReducer;